import { forwardRef, Ref, SVGProps } from 'react'

function _IconLowBattery(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      ref={ref}
    >
      <path
        d="M3.33317 12H1.99984C1.64622 12 1.30708 11.8595 1.05703 11.6095C0.80698 11.3594 0.666504 11.0203 0.666504 10.6667V5.33333C0.666504 4.97971 0.80698 4.64057 1.05703 4.39052C1.30708 4.14048 1.64622 4 1.99984 4H4.1265M9.99984 4H11.3332C11.6868 4 12.0259 4.14048 12.276 4.39052C12.526 4.64057 12.6665 4.97971 12.6665 5.33333V10.6667C12.6665 11.0203 12.526 11.3594 12.276 11.6095C12.0259 11.8595 11.6868 12 11.3332 12H9.2065"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3335 8.66732V7.33398"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33317 4L4.6665 8H8.6665L5.99984 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconLowBattery = forwardRef(_IconLowBattery)
